class DocumentReference {
	typeCode: string = '';
	identifier: string;
	constructor(typeCode: string, identifier: string) {
		this.typeCode = typeCode;
		this.identifier = identifier;
	}
}

class Data {
	content: number = 0;
	typeCode: string = '';
	constructor(content: number, typeCode: string) {
		this.content = content;
		this.typeCode = typeCode;
	}
}

class Code {
	content: string = '';
	typeCode: string = '';
	constructor(content: string, typeCode: string) {
		this.content = content;
		this.typeCode = typeCode;
	}
}

class Identifier {
	identifier: number;
	constructor(id: number) {
		this.identifier = id;
	}
}

class ExtensionSchema {
	typeCode: string = '';
	amount: Array<Data> = [];
	code: Array<Code> = [];

	constructor(typeCode: string, amount: Array<Data>, code: Array<Code>) {
		this.typeCode = typeCode;
		this.amount = amount;
		this.code = code;
	}
}

export class DMC {
	typeCode: string = 'DMC';
	identifierSet: Identifier;
	quantity: Array<Data>;
	extension: ExtensionSchema;
	percentage: Data;

	constructor(typeCode: string, identifier: number) {
		this.typeCode = typeCode;
		this.identifierSet = { identifier: identifier };
		this.quantity = [];
		this.extension = new ExtensionSchema(
			'',
			[{ content: 0, typeCode: 'DMC Amount' }],
			[]
		);

		this.percentage = new Data(0, 'Allocation Percent');
	}
}
